<mat-form-field
  [appearance]="appearance()"
  [floatLabel]="!control.value ? 'always' : 'auto'"
  class="w-full relative"
>
  <mat-label [attr.for]="id()">{{ label() }}</mat-label>
  <input
    type="text"
    matInput
    [attr.id]="id()"
    [attr.name]="name() || id()"
    [placeholder]="placeholder()"
    [formControl]="control"
    [matAutocomplete]="auto"
    (blur)="onBlur()"
  />
  @if (isLoading()) {
    <mat-spinner matSuffix diameter="18"></mat-spinner>
  } @else if (isVerified) {
    <mat-icon matSuffix class="text-green-600">check_circle</mat-icon>
  }
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    @for (option of options(); track option.id ?? ($index + '-' + option.via)) {
      <mat-option [value]="option">
        {{ option.via }}
        @if (option.comune) {
          <span class="text-xs opacity-60 ml-1">{{ option.comune }}</span>
        }
      </mat-option>
    }
    @if (showNoResults) {
      <mat-option [disabled]="true">Nessun indirizzo trovato</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
<mat-error siatErrorField [control]="control" [label]="label()"></mat-error>
